export const mapFiscalInvoiceToSummary = (fiscal) => {
  if (!fiscal) return null;
  return {
    traderSystemInvoiceNumber: fiscal.traderSystemInvoiceNumber,
    invoiceNo: fiscal.invoiceNo,
    customerName: fiscal.customerName,
    sdcId: fiscal.sdcId,
    cuReceiptNo: fiscal.cuReceiptNo,
    invoiceDate: fiscal.invoiceDate,
    status: fiscal.status,
    creditStatus: fiscal.creditStatus,
    totalInvoiceAmount: fiscal.totalInvoiceAmount,
    totalTaxAmount: fiscal.totalTaxAmount,
    totalTaxableAmount: fiscal.totalTaxableAmount,
    totalDiscount: fiscal.totalDiscount,
  };
};
